import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
// const LazyLoadComponent = ({ children, forwardedRef }) => {
//   const [isVisible, setIsVisible] = useState(false);
//   const localRef = useRef(null);
//   const ref = forwardedRef || localRef;

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       (entries) => {
//         entries.forEach((entry) => {
//           if (entry.isIntersecting) {
//             setIsVisible(true);
//           } else {
//             setIsVisible(false);
//           }
//         });
//       },
//       {
//         threshold: 0.2, // Adjust threshold as needed
//       }
//     );

//     if (ref.current) {
//       observer.observe(ref.current);
//     }

//     return () => {
//       if (ref.current) {
//         observer.unobserve(ref.current);
//       }
//     };
//   }, [ref]);

//   return (
//     <div
//       ref={ref}
//       style={{
//         opacity: isVisible ? 1 : 0,
//         transform: isVisible ? "translateY(0)" : "translateY(50px)",
//         transition: "opacity 0.3s ease-out, transform 0.3s ease-out",
//       }}
//     >
//       {children}
//     </div>
//   );
// };

// export default LazyLoadComponent;

const LazyLoadComponent = ({ forwardedRef, children }) => {
  const innerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );
    if (innerRef.current) observer.observe(innerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={forwardedRef}>
      <motion.div
        ref={innerRef}
        initial={{ opacity: 0, y: 40 }}
        animate={isVisible ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6 }}
      >
        {children}
      </motion.div>
    </div>
  );
};

export default LazyLoadComponent;
